export enum ApiCallStatus {
  Initial = 'Initial',
  Pending = 'Pending',
  Success = 'Success',
  Error = 'Error',
  Done = 'Done',
}
